<h1 class="page-header" mat-dialog-title *ngIf="action=== TwoFaActionType.ENABLE_TFA">
  <span>Enable two-factor authentication</span>
</h1>
<h1 class="page-header" mat-dialog-title *ngIf="action=== TwoFaActionType.DISABLE_TFA">
  <span>Disable two-factor authentication</span>
</h1>
<h1 class="page-header" mat-dialog-title *ngIf="action=== TwoFaActionType.CREATE_RECOVERY_KEY">
  <span>Create new recovery key</span>
</h1>

<div mat-dialog-content class="!pb-5">
  <div [hidden]="step !== 1">
    <b3n-twofa-verifyEmail
      [email]="email"
      [tfaInfo]="tfaInfo"
      [action]="action"
      (finishVerifyEmailEvent)="finishStep($event)"
    ></b3n-twofa-verifyEmail>
  </div>
  <div [hidden]="step !== 2">
    <b3n-twofa-saveRecoveryCode [tfaInfo]="tfaInfo" (actionEvent)="doActionStep2($event)"> </b3n-twofa-saveRecoveryCode>
  </div>
</div>
